import React from 'react'
import { Popup } from 'semantic-ui-react'
import { currencyFormat } from '../../../../utils/currencyFormat'

type Props = {
  widgetValues: { paid: number, canceled: number, receivable: number, remaining: number, total: number }
  total_budget: number
  popup?: boolean
  height?: string
}

const ServiceProviderPTCProgress = (props: Props): JSX.Element => {

  const { widgetValues, total_budget, popup, height } = props
  const popupContent = () => {
    return (
      <div>
        <div style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>Pass Through Status</div>
        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#B882FB', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Passed Through</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF', fontWeight: 500 }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.paid)[0]} {currencyFormat(widgetValues.paid).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.paid).split(',')[1]}</p>
          </div>
        </div>

        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#D9BCFE', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Receivable</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF' }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.receivable)[0]} {currencyFormat(widgetValues.receivable).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.receivable).split(',')[1]}</p>
          </div>
        </div>

        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#FFB154', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Closed</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF' }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.canceled)[0]} {currencyFormat(widgetValues.canceled).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.canceled).split(',')[1]}</p>
          </div>
        </div>

        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#F3F3F3', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Remaining</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF' }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.remaining)[0]} {currencyFormat(widgetValues.remaining).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.remaining).split(',')[1]}</p>
          </div>
        </div>
        <div style={{ display: 'flex', fontSize: '0.9rem', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <div style={{ background: '#747678', borderRadius: '50%', width: '10px', height: '10px', marginRight: '0.5rem' }}></div>
            <div>Total</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', float: 'left', color: '#FFF' }}>
            <p style={{ margin: 0 }}>{currencyFormat(widgetValues.total)[0]} {currencyFormat(widgetValues.total).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ margin: 0 }}>,{currencyFormat(widgetValues.total).split(',')[1]}</p>
          </div>
        </div>
      </div>
    )
  }

  const subBarValues = () => {
    return (
      <div style={{ width: '100%', display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
        {/* Passed Through */}
        <div style={{ alignItems: 'flex-start', minWidth: '10%', width: `${(widgetValues.paid / widgetValues.total) * 100}%`, height: '5rem', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '1.4rem', display: 'flex', alignItems: 'center', float: 'left', fontWeight: 600 }}>
            <p style={{ color: '#B882FB', margin: 0 }}>{currencyFormat(widgetValues.paid)[0]} {currencyFormat(widgetValues.paid).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ color: '#BEC8C3', margin: 0 }}>,{currencyFormat(widgetValues.paid).split(',')[1]}</p>
          </div>
          <div style={{ color: '#747678', fontSize: '1.2rem', float: 'left', fontWeight: 600, marginTop: '0.3rem' }}>Passed Through</div>
        </div>
        {/* End */}
        {/* Receivable */}
        <div style={{ alignItems: 'flex-start', minWidth: '10%', width: `${(widgetValues.receivable / widgetValues.total) * 100}%`, height: '5rem', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '1.4rem', display: 'flex', alignItems: 'center', float: 'left', fontWeight: 600 }}>
            <p style={{ color: '#D9BCFE', margin: 0 }}>{currencyFormat(widgetValues.receivable)[0]} {currencyFormat(widgetValues.receivable).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ color: '#BEC8C3', margin: 0 }}>,{currencyFormat(widgetValues.receivable).split(',')[1]}</p>
          </div>
          <div style={{ color: '#747678', fontSize: '1.2rem', float: 'left', fontWeight: 600, marginTop: '0.3rem' }}>Receivable</div>
        </div>
        {/* End */}
        {/* Canceled */}
        {widgetValues.canceled > 0 ? <div style={{ alignItems: 'flex-start', minWidth: '10%', width: `${(widgetValues.canceled / widgetValues.total) * 100}%`, height: '5rem', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '1.4rem', display: 'flex', alignItems: 'center', float: 'left', fontWeight: 600 }}>
            <p style={{ color: '#FFB154', margin: 0 }}>{currencyFormat(widgetValues.canceled)[0]} {currencyFormat(widgetValues.canceled).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ color: '#BEC8C3', margin: 0 }}>,{currencyFormat(widgetValues.canceled).split(',')[1]}</p>
          </div>
          <div style={{ color: '#747678', fontSize: '1.2rem', float: 'left', fontWeight: 600, marginTop: '0.3rem' }}>Canceled</div>
        </div> : null}
        {/* End */}
        {/* Remaining */}
        <div style={{ alignItems: 'flex-end', minWidth: '10%', width: `${(widgetValues.remaining / widgetValues.total) * 100}%`, height: '5rem', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '1.4rem', display: 'flex', alignItems: 'center', float: 'left', fontWeight: 600 }}>
            <p style={{ color: '#747678', margin: 0 }}>{currencyFormat(widgetValues.remaining)[0]} {currencyFormat(widgetValues.remaining).split(',')[0].replace(currencyFormat(total_budget ? +total_budget : 0)[0], '')}</p>
            <p style={{ color: '#BEC8C3', margin: 0 }}>,{currencyFormat(widgetValues.remaining).split(',')[1]}</p>
          </div>
          <div style={{ color: '#747678', fontSize: '1.2rem', float: 'right', fontWeight: 600, marginTop: '0.3rem' }}>Remaining</div>
        </div>
        {/* End */}
      </div>
    )
  }

  const renderBar = () => {
    const valuePaid = (widgetValues.paid / widgetValues.total) * 100
    const valueCanceld = (widgetValues.canceled / widgetValues.total) * 100
    const valueRemaining = (widgetValues.remaining / widgetValues.total) * 100
    const valueReceivable = (widgetValues.receivable / widgetValues.total) * 100
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ borderRadius: '7px', width: '100%', display: 'flex', flexDirection: 'row', backgroundColor: '#747678' }}>
          <div style={{ borderTopLeftRadius: '7px', borderBottomLeftRadius: '7px', borderTopRightRadius: valuePaid >= 100 ? '7px' : '0', borderBottomRightRadius: valuePaid >= 100 ? '7px' : '0', backgroundColor: '#B882FB', width: `${valuePaid}%`, height: height ?? '1rem' }}></div>
          <div style={{ backgroundColor: '#D9BCFE', width: `${valueReceivable}%`, height: height ?? '1rem' }}></div>
          <div style={{ backgroundColor: '#FFB154', width: `${valueCanceld}%`, height: height ?? '1rem' }}></div>
          <div style={{ borderTopLeftRadius: valueRemaining >= 100 ? '7px' : '0px', borderBottomLeftRadius: valueRemaining >= 100 ? '7px' : '0px', borderTopRightRadius: '7px', borderBottomRightRadius: '7px', backgroundColor: '#F3F3F3', width: `${valueRemaining}%`, height: height ?? '1rem' }}></div>
        </div>
        {!popup && popup !== undefined ? subBarValues() : null}
      </div>
    )
  }

  if (!popup && popup !== undefined) {
    return renderBar()
  }

  const valuePaid = Math.round((widgetValues.paid / widgetValues.total) * 100)
  const valueCanceld = Math.round((widgetValues.canceled / widgetValues.total) * 100)
  const valueRemaining = Math.round((widgetValues.remaining / widgetValues.total) * 100)
  const valueReceivable = Math.round((widgetValues.receivable / widgetValues.total) * 100)
  return (
    <Popup
      on='hover'
      hoverable
      trigger={
        <div style={{ borderRadius: '7px', width: '100%', display: 'flex', flexDirection: 'row', backgroundColor: '#F3F3F3' }}>
          <div
            style={{
              borderTopLeftRadius: '7px',
              borderBottomLeftRadius: '7px',
              borderTopRightRadius: valueRemaining >= 100 ? '7px' : '0px',
              borderBottomRightRadius: valueRemaining >= 100 ? '7px' : '0px',
              backgroundColor: '#B882FB',
              width: `${valuePaid}%`,
              height: height ?? '1rem'
            }}>
          </div>
          <div
            style={{
              borderTopLeftRadius: valuePaid ? '0px' : '7px',
              borderBottomLeftRadius: valuePaid ? '0px' : '7px',
              borderTopRightRadius: valueCanceld  || valueRemaining ? '0px' : '7px',
              borderBottomRightRadius: valueCanceld  || valueRemaining ? '0px' : '7px',
              backgroundColor: '#D9BCFE',
              width: valueReceivable ? `${valueReceivable}%` : 0,
              height: height ?? '1rem'
            }}>
          </div>
          <div style={{
            borderTopLeftRadius: valueReceivable || valuePaid  ? '0px' : '7px',
            borderBottomLeftRadius: valueReceivable || valuePaid  ? '0px' : '7px',
            borderTopRightRadius:  valueRemaining && valueRemaining >= 0 ? '0px' : '7px',
            borderBottomRightRadius: valueRemaining && valueRemaining >= 0 ? '0px' : '7px',
            backgroundColor: '#FFB154',
            width: valueCanceld ? `${valueCanceld}%` : 0,
            height: height ?? '1rem'
          }}></div>
          <div
            style={{
              borderTopLeftRadius: valueCanceld || valueReceivable || valuePaid ? '0px' : '7px',
              borderBottomLeftRadius: valueCanceld || valueReceivable || valuePaid ? '0px' : '7px',
              borderTopRightRadius: '7px',
              borderBottomRightRadius: '7px',
              backgroundColor: '#F3F3F3',
              width: valueRemaining ? `${valueRemaining}%`: 0,
              height: height ?? '1rem'
            }}>
          </div>
        </div>
      }
      style={{ backgroundColor: '#4E5579', color: '#FFF', borderRadius: '8px', minWidth: '16rem', minHeight: '10rem' }}
      className='popup-info'
      content={popupContent()}
      position='bottom center'
      offset={[-100, 0]}
    />
  )
}

export default ServiceProviderPTCProgress
